import React from "react";
import Banner from "../../img/cubelogin.png";
import banners from "../../img/cubee.png"

const Webimagefooter = () => {
  return (
    <>
   
    <div className="w-full mt-[0px] hidden    md:block ">
      <img src={Banner} alt=""  className=" h-[200px] w-[355px]" />
    </div>
      <div className="w-full mt-[-0px] block   md:hidden">
      <img src={banners} alt=""  className=" h-[200px] w-[200px]" />
    </div>
     </>
  );
};

export default Webimagefooter;
